export default {
    infoIcon: {
        marginTop: "5px",
        "& path": {
            fill: "none",
            stroke: ({ palette }) => palette.greyscale[600]
        }
    }
};
